import { SessionStorageKey } from "@components/refactored-survey/question-sets/insurance-survey-questions/utils/SessionStorageKey";

// This is `true` for users have completed the telehealth insurance survey
// pre-payment and need to complete patient intake after checkout.
export const getIsTelehealthPlan = (): boolean =>
  sessionStorage.getItem(SessionStorageKey.isTelehealthPlan) ===
  true.toString();

export const setIsTelehealthPlan = (value: boolean) =>
  sessionStorage.setItem(SessionStorageKey.isTelehealthPlan, value.toString());
